import { AirconLocalityPage } from '../../../../components/market/AirconLocalityPage'
import { getAirconPageProps } from '../../../../lib/market-pages'
import { getCity } from '../../../../utils/markets'
import localities from '../../../../data/markets/ae/aircon/dubai/localities'

const CONTENT_REVIEWED = '2026-10-03'
const COUNTRY = 'ae'
const CITY = 'dubai'

// Paths come from utils/markets.js (the locality list); copy comes from the
// localities module. A locality without copy fails the build rather than
// shipping an empty page.
export const getStaticPaths = () => ({
    paths: getCity(COUNTRY, CITY).localities.map((l) => {
        if (!localities[l.slug]) throw new Error(`[locality] no copy for ${COUNTRY}/${CITY}/${l.slug}`)
        return { params: { locality: l.slug } }
    }),
    fallback: false,
})

export const getStaticProps = async ({ params }) => {
    const result = await getAirconPageProps(COUNTRY, CITY, CONTENT_REVIEWED)
    return { ...result, props: { ...result.props, localitySlug: params.locality } }
}

export default function Page(props) {
    return <AirconLocalityPage {...props} copy={localities[props.localitySlug]} />
}
